import flags from 'react-phone-number-input/flags'
import { type CountryCode } from 'libphonenumber-js'
import en from 'react-phone-number-input/locale/en.json'
import type { CSSProperties } from 'react'

interface ICountryFlagProps {
  country: CountryCode
  width?: CSSProperties['width']
  height?: CSSProperties['height']
}

export const CountryFlag = ({ country, width = 16, height }: ICountryFlagProps) => {
  const Flag = flags[country]

  if (!Flag) return null

  return (
    <div style={{ display: 'flex', alignItems: 'center', width, height }}>
      <Flag title={en[country]} />
    </div>
  )
}
